import { configureStore } from "@reduxjs/toolkit";

// There was an RTK Query service here for CryptoCompare. Its hook was never
// called anywhere - the charts always used a plain fetch - so it was a reducer
// and a middleware listener kept alive for nothing, holding the last reference
// to the API key. It went with the provider.

import timeReducer from "./slices/timeCustomSlice";
import cryptoDataReducer from "./slices/chartSymbolSlice";

export const store = configureStore({
  reducer: {
    time: timeReducer,
    cryptocurrencyData: cryptoDataReducer,
  },
});
